<template>
<div id="messageLog">
  <div class="allSearch">
    <div class="newSearch d_flex">
      <div style="width: auto;white-space: normal">
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="调用方" type="text" style="" v-model="postData.from">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="模板消息名称" type="text" style="" v-model="postData.name">
        </p>
        <button class="redButton" @click="getList(1)">搜索</button>
      </div>
    </div>
  </div>
  <div class="allTablePlace">
    <div>
      <table cellspacing="0" class="allTable">
        <thead>
        <tr>
          <th>调用方</th>
          <th class="">模板消息名称</th>
          <th class="">最后一次调用时间</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr :key="index" v-for="(item, index) in myList">
          <td>{{item.from}}</td>
          <td class="">{{item.name}}</td>
          <td class="NoWrap" style="">{{item.lastCallTime}}</td>
          <td width="10%">
            <span  @click="getDetail(item)" class="colorRed c_p">查看</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <page v-if="totalPage !== 0" v-on:on-getList="getList($event)" :totalCount="totalCount" :totalPage="totalPage" :page="page" :explain="0"></page>
    <model v-if="showModel" :buttonType="0" :title="'查看详情'" :minWidth="'1100px'" v-on:on-cancel="showModel = false" v-on:on-confirm="showModel = false">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
        <div class="newSearch m_b_20">
          <div style="white-space: normal">
            <p class="d_i">
              <cander v-model="detailPostData.startTime" :className="'allInput'" placeholderName="开始时间"  class="d_i" style="vertical-align: middle"></cander>
            </p>
            <p class="d_i">
              <cander v-model="detailPostData.endTime" :minDate="detailPostData.startTime" :className="'allInput'" placeholderName="结束时间"  class="d_i" style="vertical-align: middle"></cander>
            </p>
            <button class="redButton d_i" @click="getDetailList(1)">搜索</button>
          </div>
        </div>
        <div style="min-height: 300px">
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>发送时间</th>
              <th class="">参数详情</th>
              <th class="">发送人数</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in myDetailList">
              <td>{{item.sendDate}}</td>
              <td class=""><div :title="item.sendData" style="max-width: 400px;overflow: hidden">{{item.sendData}}</div></td>
              <td class="NoWrap" style="">{{item.sendCount}}</td>
              <td width="10%"><span @click="exportExcel(item)" class="c_p colorRed">导出明细</span></td>
            </tr>
            </tbody>
          </table>
        </div>
        <page v-if="detailTotalPage !== 0" v-on:on-getList="getDetailList($event)" :totalCount="detailTotalCount" :totalPage="detailTotalPage" :page="detailPage" :explain="0"></page>
      </div>
    </model>
  </div>
</div>
</template>

<script>
export default {
  name: 'messageLog',
  data () {
    return {
      baseUrl: process.env.config.baseUrl,
      showModel: false,
      postData: {
        from: '',
        name: '',
        lastTime: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      detailPostData: {
        templateId: '',
        name: '',
        startTime: '',
        endTime: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      totalPage: 1,
      detailTotalPage: 1,
      totalCount: 0,
      detailTotalCount: 0,
      page: 1,
      detailPage: 1,
      myList: [
      ],
      myDetailList: []
    }
  },
  created () {
    this.getList(1)
  },
  methods: {
    getDetail (item) {
      this.detailPostData.templateId = item.templateId
      this.detailPostData.from = item.from
      this.detailPostData.name = item.from
      this.getDetailList(1)
      this.showModel = true
    },
    getDetailList (pageIndex) {
      this.detailPostData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.detailPostData))
      if (data.startTime) {
        data.startTime = data.startTime + ' 00:00:00'
      }
      if (data.endTime) {
        data.endTime = data.endTime + ' 23:59:59'
      }
      let url = this.$commonJs.returnQuery('/api/MessageManagement/GetTplMsgSendLogDetail', data)
      this.$axiox.getList(url).then(msg => {
        this.myDetailList = msg.data
        this.detailPage = pageIndex
        this.detailTotalPage = Math.ceil(msg.total / this.detailPostData.PageSize)
        this.detailTotalCount = msg.total
      })
    },
    exportExcel (item) {
      var xmlResquest = new XMLHttpRequest()
      if (window.XMLHttpRequest) { // Mozilla 浏览器
        xmlResquest = new XMLHttpRequest()
      } else {
        if (window.ActiveXObject) { // IE 浏览器
          try {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Msxml2.XMLHTTP')
          }
        }
      }
      xmlResquest.open('GET', this.baseUrl + '/api/MessageManagement/ExportTmplMsgDetail?templateId=' + this.detailPostData.templateId + '&name=' + this.detailPostData.name + '&transactionid=' + item.transactionId, true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('TaToken'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = '导出明细.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
      // this.$axiox.get('/api/Group/' + id + '/export?groupName=' + name).then(msg => {
      // })
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/MessageManagement/GetTplMsgSendLog', data)
      this.$axiox.getList(url).then(msg => {
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/messageManager/messageLog.vue